module.exports = __webpack_public_path__ + "img/stat_basic_ru.cd783af6.png";